const STORAGE_KEY = 'meister.incomingInvoiceMailboxPending';

export type IncomingInvoiceMailboxPending = {
  email?: string;
  returnPath: string;
};

export function setIncomingInvoiceMailboxPending(pending: IncomingInvoiceMailboxPending) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
  } catch {
    // ignore quota / private mode
  }
}

export function peekIncomingInvoiceMailboxPending(): IncomingInvoiceMailboxPending | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as IncomingInvoiceMailboxPending;
    if (!parsed?.returnPath) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearIncomingInvoiceMailboxPending() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
